import { Skeleton, Stack } from '@presov.sk/presov-ui-react';

const FeedItemSkeleton: React.FC = () => {
  return (
    <Stack gap={0}>
      <Skeleton variant='rectangular' width={'100%'} height={200} />
      <Stack gap={1} p={1.5}>
        <Skeleton variant='rectangular' width={150} height={22} />
        <Skeleton variant='rectangular' width={'100%'} height={60} />
        <Stack
          direction={'row'}
          alignItems={'center'}
          justifyContent={'space-between'}
          mt={1}
        >
          <Skeleton variant='rectangular' width={120} height={20} />
          <Skeleton variant='rectangular' width={80} height={20} />
        </Stack>
      </Stack>
    </Stack>
  );
};

export default FeedItemSkeleton;
